import React, { useCallback, useEffect, useRef, useState } from 'react';
import everpassLogo from '../../assets/everpassLogo.svg';
import suitcase from '../../assets/suitcase.svg';
import './ReadinessSuccess.scss';

const AUTO_CLOSE_SEC = 60;

export default function ReadinessSuccess({ onDismiss }) {
    const [remaining, setRemaining] = useState(AUTO_CLOSE_SEC);
    const dismissCalled = useRef(false);

    const dismiss = useCallback(() => {
        if (dismissCalled.current) return;
        dismissCalled.current = true;
        onDismiss();
    }, [onDismiss]);

    useEffect(() => {
        const t = setInterval(() => setRemaining(r => r - 1), 1000);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        if (remaining <= 0) dismiss();
    }, [remaining, dismiss]);

    // Capture-phase keydown so remote Enter/Accept fires Close before EPG sees it.
    useEffect(() => {
        const handleKey = (e) => {
            if (!['Enter', ' ', 'Return', 'Accept'].includes(e.key)) return;
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();
            dismiss();
        };
        window.addEventListener('keydown', handleKey, { capture: true });
        return () => window.removeEventListener('keydown', handleKey, { capture: true });
    }, [dismiss]);

    return (
        <div className="RkSuccess" role="status" aria-live="polite" aria-label="Streaming diagnostics complete">
            <p className="RkSuccess__eyebrow">
                <img className="RkSuccess__eyebrow-icon" src={suitcase} alt="" />
                Streaming Diagnostic
            </p>

            <div className="RkSuccess__body">
                <svg className="RkSuccess__check" width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
                    <circle cx="36" cy="36" r="36" fill="#2fd07a" />
                    <polyline points="20,37 30,49 52,24" stroke="white" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <h1 className="RkSuccess__title">Your Setup is Ready</h1>
                <div className="RkSuccess__subtitle">
                    <p>We have checked your setup and you&apos;re ready</p>
                    <p>to stream. Close now or wait to continue.</p>
                </div>
            </div>

            <div className="RkSuccess__footer">
                <img className="RkSuccess__logo" src={everpassLogo} alt="EverPass" />
                <span className="RkSuccess__countdown">Auto-closing in {remaining}s</span>
                <button className="RkSuccess__close RkSuccess__close--focused" onClick={dismiss}>
                    Close
                </button>
            </div>
        </div>
    );
}
